import React, { useEffect, useState } from "react";
import Select from "react-select";
import GeneralApiService from "../../../services/generalServices";

const CategoryMenu = ({ handleCategoryChange }) => {
  const [category, setCategory] = useState(null);
  const [categories, setCategories] = useState([]);

  const fetchCategory = async () => {
    try {
      const generalServices = new GeneralApiService();
      generalServices.getCategoryList().then((response) => {
        if (response && response.isSuccess) {
          console.log(response.result, "--------->");
          setCategories(response.result);

          if (response.result.length > 0) {
            setCategory(response.result[0]);
            handleCategoryChange("Not");
          }
        } else {
          setCategories([]);
        }
      });
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const handleSelectChange = (selectedOption) => {
    setCategory(selectedOption);
    if (handleCategoryChange) handleCategoryChange(selectedOption);
  };

  return (
    <>
      {handleCategoryChange && (
        <div style={{ maxWidth: "200px" }}>
          <Select
            options={categories}
            value={category}
            onChange={handleSelectChange}
            placeholder="Choose a category"
            styles={{
              control: (base) => ({
                ...base,
                minWidth: "200px",
              }),
              menu: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
          />
        </div>
      )}
    </>
  );
};

export default CategoryMenu;
